<template>
  <div>
<!-- 		<div id="package" class="package"> -->
			<h2 class="pt-3 pb-3" style="text-align: center;"><strong>PROFIL LEMBAGA PENYELENGGARA PKBM BINA PANDU MANDIRI</strong></h2>
			<div class="container overflow-hidden">
				<div class="row pb-2">
					<div class="col">
						<div class="p-3 border bg-light">
							<h4>A. LATAR BELAKANG</h4>
							<p class="text-justify">
								Pusat Kegiatan Belajar Masyarakat (PKBM) sebagai salah satu satuan pendidikan nonformal merupakan wadah mengintensifkan dan mengkoordinasikan berbagai kegiatan pembelajaran masyarakat dalam upaya meningkatkan pengetahuan, keterampilan dan sikap mental (masyarakat) untuk mengembangkan diri dan meningkatkan kualitas hidup.
							</p>
							<p class="text-justify">
								Keberadaan PKBM memiliki potensi besar untuk dijadikan basis koordinasi program pembelajaran masyarakat, khusus di PKBM Bina Pandu Mandiri Kecamatan Ciamis Kabupaten Ciamis.
							</p>
						</div>
					</div>
				</div>
				<div class="row pb-2">
					<div class="col">
						<div class="p-3 border bg-light">
							<h4>B. LANDASAN HUKUM</h4>
							<ol type="a">
								<li><b>Landasan Idiil</b>
									<p>Undang-Undang Dasar 1945</p>
								</li>
								<li><b>Landasan Operasional</b>
									<ol>
										<li class="text-justify">Undang-Undang No. 20 tahun 2003 tentang Sistem Pendidikan Nasional</li>
										<li class="text-justify">Peraturan Pemerintah No. 73 tahun 1999 tentang Pendidikan Luar Sekolah</li>
										<li class="text-justify">Keputusan Mendiknas Nomor 25 Tahun 1999, tentang Kewenangan Antara Pemerintah Pusat dan Daerah</li>
										<li class="text-justify">Keputusan Menteri Pendidikan dan Kebudayaan Republik Indonesia;</li>
										<li class="text-justify">Surat Edaran Gubernur Jawa Barat Nomor : 420/17/Binsos/2000 tentang Pembentukan PKBM.</li>
										<li class="text-justify">Surat Kepala Kanwil Depdiknas Provinsi Jawa Barat Nomor : 21/102.3/MS/2000 tentang Pembentukan PKBM</li>
										<li class="text-justify"><b>Standar Dan Prosedur Penyelenggaraan Pusat Kegiatan Belajar Masyarakat (PKBM)</b></li>
									</ol>
								</li>
							</ol>
						</div>
					</div>
					<div class="col">
						<div class="p-3 border bg-light">
							<h4>C. VISI, MISI, MOTTO DAN TUJUAN</h4>
							<ol type="a">
								<li><b>Visi</b>
									<p class="text-justify">Terwujudnya masyarakat yang edukatif, inovatif, kreatif dan produktif</p>
								</li>
								<li><b>Misi</b>
									<ol>
										<li class="text-justify">Menyelenggarakan Pendidikan yang berkwalitas</li>
										<li class="text-justify">Menyelenggarakan Pendidikan dan latihan yang berwawasan pada kecakapan hidup</li>
										<li class="text-justify">Membangkitkan minat membaca masyarakat melalui TBM</li>
										<li class="text-justify">Menjalin keharmonisan dengan lembaga pendidikan formal dan non formal serta masyarakat</li>
										<li class="text-justify">Mewujudkan masyarakat hidup berbudaya dan religius yang berkesinambungan</li>
									</ol>
								</li>
								<li><b>Motto</b>
									<p class="text-justify">Membantu yang membutuhkan, menjangkau yang belum sampai</p>
								</li>
								<li><b>Tujuan Umum</b>
									<p class="text-justify">Memperluas kesempatan warga, untuk meningkatkan pengetahuan, keterampilan, dan sikap mental yang diperlukan untuk mengembangkan diri dan meningkatkan kualitas hidup.</p>
								</li>
								<li><b>Tujuan Khusus</b>
									<ol>
										<li class="text-justify">Merubah pola pikir masyarakat untuk memperbaiki taraf hidup dan pendapatan dengan pendekatan pembelajaran,</li>
										<li class="text-justify">membantu pemerintah mengurangi laju pertumbuhan drop-out (DO) pada jenjang pendidikan Dasar dan Menengah paket A, B & C,</li>
										<li class="text-justify">Menanamkan jiwa kewirausahaan berlandaskan akhlak mulia.</li>
									</ol>
								</li>
							</ol>
						</div>
					</div>
				</div>
				<div class="row pb-2">
					<div class="col">
						<div class="p-3 border bg-light">
							<h4>D. MODEL PKBM</h4>
							<p class="text-justify">
								PKBM yang kami kelola bermodel <b>PKBM satelit</b>, artinya bahwa Sistem pelaksanaan pembelajaran berada di lingkungan tempat beradanya warga belajar. Tutor datang ke tempat pembelajaran, dan tempat inilah yang di namakan pos pelayanan <b>(POSYAN)</b>. Olehkarena itu sekretariat hanya tempat untuk memonitoring KBM di tiap POSYAN. terdapat 10 Posyan yang kami miliki sampai saat ini yang tersebar di 9 Kecamatan. Dengan rincian terlampir.
							</p>
						</div>
					</div>
					<div class="col">
						<div class="p-3 border bg-light">
							<h4>E. MODA PEMBELAJARAN</h4>
							PKBM Bina Pandu Mandiri dalam melaksanakan pembelajarannya mengalami beberapa penggunaaan moda.
							<ol>
								<li class="text-justify">Pada awal penyelenggaraan  2005-2006 adalah adalah dengan cara belajar kovensional (tatap muka )</li>
								<li class="text-justify">Pada tahun 2006-2015 adalah Kovensional Mobile (tatap muka dengan tutor mnjangkau WB)</li>
								<li class="text-justify">Pada tahun 2016-2018 adalah menggunakan pembelajaran Daring (dalam jaringan) </li>
								<li class="text-justify">Pada tahun 2018 sampai sekarang adalah menggunakan kombinasi, yakni pembelajaran tatap muka yang di kombinasikan dengan daring atau yang di kenal dengan <b>blended learning.</b></li>
							</ol>
							<b>blended learning</b> yang dilaksanakan dengan bentuk KBM berupa :
							<ol type="a">
								<li>Belajar mandiri  50%</li>
								<li>Belajar tutorial 30%</li>
								<li>Belajar Tatap muka 20%</li>
							</ol>
							yang keseluruhan bentuk  belajar dengan pendekatan belajar <b>andragogi.</b>
						</div> 
					</div>
				</div>
				<div class="row pb-2">
					<div class="col">
						<div class="p-3 border bg-light">
							<h4>F. ORGANISASI PKBM</h4>
							<div class="horizontal-overflow">
								<table class="table "
									responsive="sm"
									show-empty
									small
								>
									<thead>
										<tr >
											<th class="">IDENTITAS PKBM</th>
										</tr>
									</thead>
									<tbody>
										<tr >
											<td>Pelindung</td>
											<td>: Bina Pandu Mandiri</td>
										</tr>
										<tr >
											<td>Badan Hukum</td>
											<td>: Akte Notaris Nivea Assegaf, SH., MH No. 22 tahun 2015</td>
										</tr>
										<tr >
											<td>Nama PKBM</td>
											<td>: Bina Pandu Mandiri</td>
										</tr>
										<tr >
											<td>Nama Ketua</td>
											<td>: Tatang Suryamiharja</td>
										</tr>
										<tr >
											<td>Alamat</td>
											<td>: Jl. Jend. Ahmad Yani no. 136 Kode Pos 46213 Ciamis</td>
										</tr>
										<tr >
											<td>Berdiri</td>
											<td>: 22 Oktober 2005</td>
										</tr>
										<tr >
											<td>Alamat email</td>
											<td>: binapandumandiri@gmail.com</td>
										</tr>
										<tr >
											<td>Instagram</td>
											<td>: https://instagram.com/pkbm_bina_pandu_mandiri</td>
										</tr>
										<tr >
											<td>Facebook</td>
											<td>: https://www.facebook.com/pkbm.binapandumandiri.96</td>
										</tr>
										<tr >
											<td>Link Pembelajaran</td>
											<td>: https://pkbm-binapandumandiri.or.id/landing-page</td>
										</tr>
										<tr >
											<td>No Kontak</td>
											<td>: Tatang Suryamiharja 081312663201 <br>
												Ili Solihudin 081320243104<br>
												Masykur Abdul Rasyid 082320221550
											</td>
										</tr>
										<tr >
											<td>Alamat email ketua</td>
											<td>: ilisolihudin1@gmail.com</td>
										</tr>
										<tr >
											<td>Rekening BRI Cabang Ciamis</td>
											<td>: <b>0104-01-006323-53-7</b></td>
										</tr>
										<tr >
											<td>Rekening BJB  Ciamis</td>
											<td>: <b>0084945854100</b><br>a.n. PKBM Bina Pandu  Mandiri.
											</td>
										</tr>
										<tr >
											<td>NPWP PKBM Bina Pandu Mandiri</td>
											<td>: <b>86.926.533.0-442.000</b></td>
										</tr>
										<tr >
											<td>NPSN</td>
											<td>: <b>P2964510</b></td>
										</tr>
									</tbody>
								</table>
							</div>
							<div class="horizontal-overflow">
								<table class="table "
									responsive="sm"
									show-empty
									small
								>
									<thead>
										<tr >
											<th class="">SUSUNAN PENGURUS </th>
										</tr>
									</thead>
									<tbody>
										<tr >
											<td>Ketua Yayasan</td>
											<td>: Drs. DIDI RUSWENDI</td>
										</tr>
										<tr >
											<td>Ketua PKBM</td>
											<td>: TATANG SURYAMIHARJA</td>
										</tr>
										<tr >
											<td>Sekretaris</td>
											<td>: MASKUR ABDUL RASYID, S.Pd.I</td>
										</tr>
										<tr >
											<td>Bendahara</td>
											<td>: ILI SOLIHUDIN, S.Ag</td>
										</tr>
										<tr >
											<td><b>PENANGGUNGJAWAB</b></td>
											<td>: </td>
										</tr>
										<tr >
											<td>1. Bidang Pendidikan</td>
											<td>: Mimin Atik Wartika, SH</td>
										</tr>
										<tr >
											<td>2. Bidang Kemitraan</td>
											<td>: Ir. Nursyamsul</td>
										</tr>
										<tr >
											<td>3. Bidang Pemasaran dan Dunia Usaha</td>
											<td>: Anwar Solehudin, S.Ag</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				<div class="row pb-2">
					<div class="col">
						<div class="p-3 border bg-light">
							<h4>G. 9 ( Sembilan ) Tupoksi – Tugas Pokok Fungsi Operator Sekolah</h4>
							<P class="text-justify">
								Data yang di inputkan operator sekolah adalah dasar – acuan bagi kebijakan-kebijakan pendidikan. 
								Sehingga operator sekolah harus bekerja ekstra teliti dan hati-hati, karena berkaitan erat dengan pencairan Dana BOS 
								atau Bantuan Operasional Sekolah, Program KIP atau Kartu Indonesia Pintar, Data Peserta Ujian Sekolah, 
								Verifikasi dan Validasi Peserta Didik, Inventaris Sekolah, bahkan apabila dibutuhkan juga akan berinteraksi dengan data 
								yang diserahkan kepada Bendahara BOS atau bendahara Bantuan Operasional Sekolah. 
								Sembilan Tupoksi tersebut antara lain:
							</P>
							<ol>
								<li>Mengelola Aplikasi DAPODIK ( Data Pokok Pendidikan )</li>
								<li>Mengelola Aplikasi PMP ( Pemetaan Mutu Pendidikan )</li>
								<li>Mengelola Aplikasi SPM ( Standar Pelayanan Minimal )</li>
								<li>Pengajuan KIP untuk melaksanakan Program PIP</li>
								<li>Pelayanan Administrasi Tata Usaha</li>
								<li>Verivikasi dan Validasi Peserta Didik</li>
								<li>Mengelola Aplikasi BIOUN</li>
								<li>Mengelola Inventaris Sarana dan Prasarana</li>
								<li>Mengelola Aplikasi Sekolah Kita</li>
							</ol>
						</div>
					</div>
				</div>
				<div class="row pb-2">
					<div class="col">
						<div class="p-3 border bg-light">
							<h4>H. PERAN DAN TANGGUNG JAWAB TUTOR</h4>
							<p class="text-justify">
								Dalam proses pembelajaran, <b>tutor</b> tidak hanya berperan untuk memberikan informasi terhadap siswa tetapi lebih jauh <b>tutor</b> dapat berperan sebagai perencana, pengatur, dan pendorong peserta didik agar dapat belajar secara efektif dan mengevaluasi dari keseluruhan proses pembelajaran.
							</p>
						</div>
					</div>
				</div>
			</div>
		<!-- </div> -->
		<div>
			<b-modal
				ref="login-modal"
				class="login-model"
				size="md"
				hide-footer
				hide-header
				no-close-on-backdrop
			>
			<login-form></login-form>
			</b-modal>
		</div>
		<!-- <img
			class="img-logo"
			src="../../assets/img/logo-daring.png"
			alt="Logo"
		/> -->
  </div>
</template>

<script>
	import LoginForm from "../../components/Main/LoginForm";
	// import { UsersIcon } from 'vue-feather-icons'
    export default {
		components: {
			LoginForm
			// UsersIcon
		},
		data() {
			return {
				showLoader: false
			}
		},
		computed: {
			
		},
		methods: {
			showModalLogin() {
				this.$refs['login-modal'].show()
			},
			showProfilePage() {
				// this.$router.replace('/profile')
				this.$router.push({ name: 'profile-page-child'  })
			},
			hideModalLogin() {
				this.$refs['login-modal'].hide()
			}
		},
		created () {
			
		}
	}
</script>
<style lang="css" scoped>
table {
  border-collapse: collapse;
  border: 0;
}
.img-logo {
    position:relative;
    left:38%;
    z-index: 999;
    top: 10%;
    height: 450px;
    width: 450px;
}
.horizontal-overflow {
  white-space: nowrap; /* Mencegah pemisahan kata */
  overflow-x: auto; /* Menampilkan scrollbar horizontal jika kontennya melebihi lebar */
  width: 100%; /* Lebar elemen sesuai kebutuhan Anda */
}
.btn-slider {
  margin-bottom: 50px;
}
.package, .data-jumlah {
	padding: 50px;
	padding-bottom: 0px;
}
.data-jumlah {
	padding-top: 25px;
}
.card-book-icon {
	color: #6d0101;
}
/* .card-book-icon:hover {
	color: white;
} */
.package-name {
	margin-top: 15px;
	margin-bottom: 15px;
}
.package-name h5 {
	color: black;
	font-weight: bold;
}
/* .package-name h5:hover {
	color: white;
} */
.package .card {
	margin: 25px;
	width: 243px;
	height: auto;
	text-align: center;
}
.package .card-head {
	margin: 25px;
	width: 1120px;
	height: auto;
	text-align: center;
}
.package .card-bodd {
	margin: 25px;
	width: 530px;
	height: auto;
	text-align: center;
}
.package .card {
	cursor: pointer;
	min-height: 150px;
}
.package-desc {
	color: #707070;
	text-align: justify;
}
.package .card:hover {
	background-color: #6d0101;
}
.data-jumlah .card {
	color: #707070;
}
.data-jumlah .card .card-body h1 {
	color: #6d0101;
}
.data-jumlah .card .card-footer p {
	font-weight: 500;
}
.data-jumlah .card:hover {
	border: 5px solid #6d0101;
}
.package .card:hover h5{
	color: white !important;
}
.package .card:hover .card-book-icon {
	color: white !important;
}
.package .card:hover .package-desc {
	color: white !important;
}
.login-form {
	padding: 25px;
}
@media (max-width:641px)  {
  .btn-slider {
    margin-bottom: 0px;
  }
  .btn-slider a {
    margin: 2px;
    font-size: 10px;
  }
}
</style>